var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 徽标
 */
import BadgeAntd from 'antd/es/badge';
import styled from 'styled-components';
export const Badge = (_a) => {
    var props = __rest(_a, []);
    return _jsx(BadgeStyled, Object.assign({}, props), void 0);
};
const BadgeStyled = styled(BadgeAntd) `
  &&& {
    // 去除白边
    .ant-badge-count,
    .ant-badge-dot {
      box-shadow: none;
    }
    .ant-badge-dot {
      width: 8px;
      height: 8px;
      min-width: 8px;
    }
    // 默认样式(单个)
    .ant-badge-count {
      width: 16px;
      height: 16px;
      min-width: auto;
      font-weight: 500;
      line-height: 16px;
      font-size: 12px;
      padding: 0 4px;
      border-radius: 10px;
      // 多个时候的样式
      &.ant-badge-multiple-words {
        width: auto;
        height: 16px;
        padding: 0 6px;
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQmFkZ2UvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOztHQUVHO0FBQ0gsT0FBTyxTQUF5QixNQUFNLGVBQWUsQ0FBQTtBQUVyRCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQTtBQUV0QyxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQXlCLENBQUMsRUFBWSxFQUFFLEVBQUU7UUFBWCxLQUFLLGNBQVYsRUFBWSxDQUFGO0lBQ3BELE9BQU8sS0FBQyxXQUFXLG9CQUFLLEtBQUssVUFBSSxDQUFBO0FBQ25DLENBQUMsQ0FBQTtBQUVELE1BQU0sV0FBVyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0NBOEJwQyxDQUFBIn0=